import React from "react";
import "./Tabbar.css";

const Tabbar = (props) => {
  return <div className="tab">{props.children}</div>;
};

export default Tabbar;
